import * as _ from 'lodash';
import { CMI5 } from '../../../const';

//----------------------------------------------------------------------------------------------------------------------
export let getLessonsAndActivitiesChecked = lessons => {
  let activitiesChecked = [];

  Object.values(lessons).forEach(lesson => {
    if (lesson.checked) activitiesChecked.push(lesson.activityId);
    Object.values(lesson.activities).forEach(activity => {
      if (activity.checked) activitiesChecked.push(activity.activityId);
    });
  });

  return activitiesChecked;
};

//----------------------------------------------------------------------------------------------------------------------
export let getActivitiesChecked = lessons => {
  let activitiesChecked = [];

  Object.values(lessons).forEach(lesson => {
    if (lesson.checked) activitiesChecked.push(lesson.activityId);
    Object.values(lesson.activities).forEach(activity => {
      if (activity.checked && !isAudioOrVideoActivity(activity)) activitiesChecked.push(activity.activityId);
    });
  });
  return activitiesChecked;
};

//----------------------------------------------------------------------------------------------------------------------
export let getAllActivities = lessons => {
  let activities = [];

  Object.values(lessons).forEach(lesson => {
    Object.values(lesson.activities).forEach(activity => {
      activities.push(activity.activityId);
    });
  });

  return activities;
};

//----------------------------------------------------------------------------------------------------------------------
let existsActivity = (activitiesIds, activityId) => {
  if (!activitiesIds) return false;

  let found = _.find(activitiesIds, id => {
    return id === activityId;
  });
  return found ? true : false;
};

//----------------------------------------------------------------------------------------------------------------------
export let getLessonsAndActivities = (activities, checkedActivities) => {
  if (!activities) return [];

  let lessons = {};

  activities.forEach(lessonActivity => {
    let newLesson = Object.assign({}, lessonActivity);
    if (checkedActivities) {
      newLesson.checked = existsActivity(checkedActivities, newLesson.activityId);
    } else {
      newLesson.checked = true;
    }
    newLesson.activities = {};
    if (lessonActivity.activities) {
      lessonActivity.activities.forEach(activity => {
        let newActivity = Object.assign({}, activity);
        if (checkedActivities) newActivity.checked = existsActivity(checkedActivities, activity.activityId);
        else newActivity.checked = true;

        newLesson.activities[activity.activityId] = newActivity;
      });
    }
    lessons[lessonActivity.activityId] = newLesson;
  });

  return lessons;
};

//----------------------------------------------------------------------------------------------------------------------
export let getAllActivitiesFromLessonsActivities = activities => {
  let lessons = getLessonsAndActivities(activities, []);
  return getAllActivities(lessons);
};

export let isAudioOrVideoActivity = activityType => {
  return activityType === CMI5.ACTIVITY_TYPE.AUDIO || activityType === CMI5.ACTIVITY_TYPE.VIDEO;
};
